// src/features/settings/SettingsPage.tsx
import { Card, LoadingBoundary } from '../../app/components/foundation';
import { ControlPlanePage } from '../../app/components/foundation/control-plane';
import { VaniaCardSkeleton, VaniaLoadingSystem, VaniaTableSkeleton } from '../../app/components/loading';
import { SettingsLiveOverview } from './components';
import { useSettings } from './hooks/useSettings';
import './styles/settings.css';

function SettingsLoadingSkeleton() {
  return (
    <VaniaLoadingSystem mode="content" label="در حال بارگذاری تنظیمات">
      <div className="grid grid-cols-1 gap-3 md:grid-cols-4">
        {Array.from({ length: 4 }, (_, index) => <VaniaCardSkeleton key={`settings-metric-${index}`} lines={2} />)}
      </div>

      <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
        <VaniaCardSkeleton lines={3} />
        <VaniaCardSkeleton lines={3} />
      </div>

      <Card noPadding className="vania-settings-table-card">
        <div className="overflow-x-auto">
          <VaniaTableSkeleton columns={3} rows={5} />
        </div>
      </Card>

      <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
        <VaniaCardSkeleton lines={2} />
        <VaniaCardSkeleton lines={2} />
      </div>
    </VaniaLoadingSystem>
  );
}

/**
 * Settings overview presentation. Data access, values, and state
 * transitions remain owned by useSettings; this component only arranges
 * the overview inside the shared Control Plane surface.
 */
export function SettingsPage() {
  const { settings, loading, error } = useSettings();
  const isInitialLoading = loading && !settings;

  return (
    <ControlPlanePage
      className="vania-settings-control-plane-page"
      title="تنظیمات"
      description="مشاهده و مدیریت گروه‌های تنظیمات پلتفرم و مقادیر پیکربندی آن‌ها."
      actions={(
        <button type="button" disabled className="vania-settings-action-placeholder" title="در فاز بعدی فعال می‌شود">
          افزودن گروه تنظیمات
        </button>
      )}
    >
      {error ? (
        <LoadingBoundary loading={false} error={error} />
      ) : isInitialLoading ? (
        <SettingsLoadingSkeleton />
      ) : (
        <LoadingBoundary loading={loading} hasData={Boolean(settings)}>
          {settings ? <SettingsLiveOverview settings={settings} /> : null}
        </LoadingBoundary>
      )}
    </ControlPlanePage>
  );
}
